let blocked = false;
let timer: ReturnType<typeof setTimeout> | undefined;

const BLOCK_MS = 600;

export function tryGranularStep(): boolean {
  if (blocked) return false;
  blocked = true;
  clearTimeout(timer);
  timer = setTimeout(() => {
    blocked = false;
  }, BLOCK_MS);
  return true;
}

export function extendGranularBlock(): void {
  blocked = true;
  clearTimeout(timer);
  timer = setTimeout(() => {
    blocked = false;
  }, BLOCK_MS);
}
